import { Link } from 'react-router-dom';
import Header from "../../components/header";
import { Footer } from "../../components/Footer";
import { MobileBottomMenu } from "../../components/mobileMenu";
import { PlansShowcase } from "../../components/PlansShowcase";
import { CTASection } from "../../components/CTASection";
import { ReactComponent as PhoneIcon } from '../../icons/telephone.svg';
import { ReactComponent as ContractIcon } from '../../icons/Contract.svg';
import { ReactComponent as SupportIcon } from '../../icons/support.svg';
import { useDeviceHook } from "../../hooks";

import "../../scss/plans.scss";
import { TrustSection } from '../../components/TrustSection';

export default function Plans() {
  const benefits = [
    {
      icon: ContractIcon,
      title: "Sin Contratos Forzosos",
      description: "Cancela cuando quieras, sin penalizaciones ni compromisos a largo plazo"
    },
    {
      icon: SupportIcon,
      title: "Soporte Técnico 24/7",
      description: "Atención personalizada cuando lo necesites, todos los días del año"
    },
    {
      icon: PhoneIcon,
      title: "Atención Personalizada",
      description: "Servicio al cliente dedicado para resolver todas tus consultas"
    }
  ];

  return (
    <div className="plans-page">
      <Header />
      <main className="plans-content">
        
        <section className="plans-hero">
          <div className="container">
            <div className="hero-content">
              <h1 className="plans-main-title">
                Planes de Internet Residencial
              </h1>
              <p className="plans-subtitle">
                Elige el plan perfecto para tu hogar - Pregunta por nuestra cobertura. 
                Internet confiable sin contratos forzosos.
              </p>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <div className="container">
            <h2 className="section-title">¿Por qué elegir Inter Home?</h2>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon-wrapper">
                    <benefit.icon className="benefit-icon" />
                  </div>
                  <h3 className="benefit-title">{benefit.title}</h3>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <PlansShowcase />
        <CTASection />
        
      </main>
      <Footer />
    </div>
  )
}
